// DO NOT EDIT
  // this file is generated by /internals/populate-icons script
  import * as React from 'react'
  // @ts-ignore
  import { Moon } from 'react-feather'
  import IconBase from './../../IconBase'

  function IconMoon(props: any) {
    return <IconBase icon={Moon} {...props} />
  }

  export default IconMoon
  